import { defineStore } from "pinia";
import { type IntakeScenarioConfiguration } from "~/api";
import { apiClient } from "~/utils/apiClient";

export const useIntakeScenarioConfigStore = defineStore(
  "IntakeScenarioConfigStore",
  {
    state: (): {
      config: IntakeScenarioConfiguration | undefined;
      isLoading: boolean;
    } => ({
      config: undefined,
      isLoading: false,
    }),
    actions: {
      async load(forceUpdate: boolean = false) {
        if (this.isLoading) return;
        if (!forceUpdate && this.config) return;

        this.isLoading = true;
        try {
          this.config =
            await apiClient.housingIntakeScenario.getIntakeScenarioConfiguration();
        } finally {
          this.isLoading = false;
        }
      },
    },
  },
);
